/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_BodyInputs */

const en_platform_plan_body = /** @type {(inputs: Platform_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick exercises from the library, set sets, reps and load, and the plan lands with your client right away.`)
};

const pl_platform_plan_body = /** @type {(inputs: Platform_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bierzesz ćwiczenia z biblioteki, ustawiasz serie, powtórzenia i ciężar, a plan od razu ląduje u podopiecznego.`)
};

/**
* | output |
* | --- |
* | "Pick exercises from the library, set sets, reps and load, and the plan lands with your client right away." |
*
* @param {Platform_Plan_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_body = /** @type {((inputs?: Platform_Plan_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_body(inputs)
	return en_platform_plan_body(inputs)
});